import Head from 'next/head';
import React from 'react';
import { DEFAULT_KEYWORDS } from './AppMeta';

const DEFAULT_TITLE = '진짜 나다운 여행 - 마이리얼트립';
const CLOUD_FRONT_URL = 'https://dffoxz5he03rp.cloudfront.net';
const DEFAULT_DESCRIPTION = '마이리얼트립에서 진짜 나다운 여행을 떠나보세요.';
const DEFAULT_URL = 'https://www.myrealtrip.com';
const OG_IMAGE = `${CLOUD_FRONT_URL}/logos/mrt_main_og_image.png`;

export interface PageMetaProps {
  title?: string;
  ogUrl?: string;
  ogImage?: string;
  description?: string;
  keywords?: string;
}

// TODO: PageMeta 업데이트
const PageMeta = ({ title, ogUrl, ogImage, description, keywords }: PageMetaProps) => {
  return (
    <>
      <Head>
        <title>{title || DEFAULT_TITLE}</title>
        <meta name="description" content={description || DEFAULT_DESCRIPTION} />
        <meta name="keywords" content={keywords || DEFAULT_KEYWORDS} />
        <meta name="format-detection" content="telephone=no" />

        <meta property="og:title" content={title || DEFAULT_TITLE} />
        <meta property="og:url" content={ogUrl || DEFAULT_URL} />
        <meta property="og:image" content={ogImage || OG_IMAGE} />
        <meta property="og:description" content={description || DEFAULT_DESCRIPTION} />

        <meta property="twitter:title" content={title || DEFAULT_TITLE} />
        <meta property="twitter:url" content={ogUrl || DEFAULT_URL} />
        <meta property="twitter:image" content={ogImage || OG_IMAGE} />
        <meta property="twitter:description" content={description || DEFAULT_DESCRIPTION} />
        {ogUrl && <link rel="canonical" href={ogUrl} />}
      </Head>
    </>
  );
};

export default PageMeta;
